import { Layout, Menu } from "antd";
import {
  UserOutlined,
  BookOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { clearToken } from "../utils/auth";
import icontecLogo from "../img/logowh.png";

const { Sider } = Layout;

export default function Sidebar() {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const logout = () => {
    clearToken();
    localStorage.clear();
    navigate("/login");
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      trigger={
        collapsed ? (
          <MenuUnfoldOutlined style={{ color: "#fff", fontSize: 18 }} />
        ) : (
          <MenuFoldOutlined style={{ color: "#fff", fontSize: 18 }} />
        )
      }
      theme="dark"
      style={{
        height: "100vh",
        overflow: "auto",
        position: "fixed",
        left: 0,
        top: 0,
        background: "linear-gradient(180deg, #36c5f4ff, #1861dfff)",
        transition: "all 0.3s ease",
        boxShadow: "2px 0 12px rgba(9, 50, 231, 0.2)",
      }}
    >
      {/* LOGO */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <img
          src={icontecLogo}
          alt="ICONTEC"
          style={{
            width: collapsed ? 40 : 60,
            marginBottom: 8,
            transition: "all 0.3s ease",
          }}
        />
        {!collapsed && (
          <span
            style={{
              color: "#fff",
              fontWeight: "bold",
              fontSize: 18,
              whiteSpace: "nowrap",
            }}
          >
            eBooks
          </span>
        )}
      </div>

      {/* MENU */}
      <Menu
        theme="dark"
        mode="inline"
        style={{ background: "transparent", borderRight: 0 }}
        onClick={({ key }) => {
          if (key === "logout") logout();
          else navigate(key);
        }}
        items={[
          {
            key: "/dashboard/usuarios",
            icon: <UserOutlined />,
            label: "Usuarios Ebooks",
          },
          {
            key: "/dashboard/ebooks",
            icon: <BookOutlined />,
            label: "eBooks",
          },
          

          {
            key: "/dashboard/ebook/cargaNormaCSV",
            icon: <BookOutlined />,
            label: "Carga Normas CSV",
          },


          {
            key: "/dashboard/cargaDoc",
            icon: <BookOutlined />,
            label: "Carga usuarios csv",
          },
          {
            key: "/dashboard/UsuariosKootobe",
            icon: <BookOutlined />,
            label: "Usuarios Kootobe",
          },

          {
            key: "logout",
            icon: <LogoutOutlined />,
            label: "Salir",
          },
        ]}
      />

      {/* ESTILOS */}
      <style>
        {`
          .ant-menu-dark.ant-menu-inline .ant-menu-item {
            color: #fff;
            font-weight: 500;
          }

          .ant-menu-item:hover {
            background: rgba(255, 255, 255, 1) !important;
            border-radius: 8px;
          }

          .ant-menu-item .anticon {
            transition: all 0.3s ease;
          }

          .ant-menu-item:hover .anticon {
            transform: scale(1.2);
            color: #ffd1d1;
          }

          .ant-layout-sider-trigger {
            background: rgba(253, 248, 248, 1);
            transition: all 0.3s ease;
          }

          .ant-layout-sider-trigger:hover {
            background: rgba(244, 234, 234, 0.68);
          }
        `}
      </style>
    </Sider>
  );
}
